export const warnedTypes = new Set();
export function resetWarnedTypes() {
  warnedTypes.clear();
}